import React from "react";
import { Card, CardContent, CardMedia, Typography, Box, Chip } from "@mui/material";
import { format } from "date-fns";
import { SxProps } from "@mui/material";
import { HONEY, PLUM } from "./reportTheme";
import { STICKER_BLEND } from "./stickers";

interface ObservationPrintCardProps {
  observation: any;
  sx?: SxProps;
  /** Decorative bee tucked into the card corner. */
  sticker?: { src: string; rotate: number };
}

const ObservationPrintCard: React.FC<ObservationPrintCardProps> = ({ observation, sx, sticker }) => {
  return (
    <Card
      variant="outlined"
      sx={{
        display: 'flex',
        maxWidth: 900,
        margin: 'auto',
        minHeight: 200,
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 4,
        border: `2px solid ${HONEY.border}`,
        backgroundColor: HONEY.card,
        ...sx,
      }}
    >
      {observation.photoUrl && (
        <CardMedia
          className="report-photo"
          component="img"
          sx={{
            width: 200,
            height: 200,
            objectFit: 'cover',
            flexShrink: 0,
            margin: 1.5,
            marginRight: 0,
            borderRadius: 3,
            border: `2px solid ${HONEY.border}`,
          }}
          image={observation.photoUrl}
          alt="Observation photo"
        />
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0 }}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', marginBottom: 1.5 }}>
            <Chip
              label={observation.category}
              sx={{ backgroundColor: PLUM.main, color: '#fff', fontWeight: 700 }}
            />
            <Typography variant="body2" sx={{ color: PLUM.soft, fontWeight: 600 }}>
              {format(new Date(observation.observationDate), 'yyyy-MMM-dd')}
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', marginBottom: 1.5 }}>
            <Chip
              size="small"
              variant="outlined"
              label={`Familiarity: ${observation.familiarity}`}
              sx={{ borderColor: HONEY.border, color: PLUM.main }}
            />
            <Chip
              size="small"
              variant="outlined"
              label={`Concentration: ${observation.concentration}`}
              sx={{ borderColor: HONEY.border, color: PLUM.main }}
            />
          </Box>

          <Typography variant="body1" sx={{ color: '#3b3b3b', paddingRight: sticker ? 6 : 0 }}>
            {observation.observationNotes}
          </Typography>
        </CardContent>
      </Box>

      {sticker && (
        <Box
          component="img"
          src={sticker.src}
          alt=""
          aria-hidden
          sx={{
            position: 'absolute',
            right: 8,
            bottom: 8,
            width: 54,
            height: 54,
            transform: `rotate(${sticker.rotate}deg)`,
            mixBlendMode: STICKER_BLEND,
            pointerEvents: 'none',
          }}
        />
      )}
    </Card>
  );
};

export default ObservationPrintCard;
